export const HOME_IMAGES = {
  HERO: "/images/home/hero-banner.png",
  ABOUT: "/images/home/about-company.jpg",
  STATS_BACKGROUND: "/images/home/stats-background.jpg",
  TESTIMONIALS_BACKGROUND: "/images/home/testimonials-background.jpg",
  CTA_BACKGROUND: "/images/home/cta-background.jpg",
};

export const ABOUT_IMAGES = {
  ONE: "/images/about/1.jpg",
  TWO: "/images/about/2.jpg",
};

export const BANNER_IMAGES = {
  HOME: "/images/banner/home-banner.png",
  ABOUT: "/images/banner/about-banner.jpg",
  SERVICES: "/images/banner/services-banner.jpg",
  PROJECTS: "/images/banner/projects-banner.jpg",
  CONTACT: "/images/banner/contact-banner.jpg",
};

export const SERVICE_IMAGES = {
  INDUSTRIAL_CONTROL_PANELS: "/images/services/industrial-control-panels.jpg",
  PANEL_BOXES: "/images/services/panel-boxes.jpg",
  ELECTRIC_BREAKERS: "/images/services/electric-breakers.jpg",
  EARTHING_ELECTRODES: "/images/services/earthing-electrodes.jpg",
  OUTDOOR_PANELS: "/images/services/outdoor-panels.jpg",
  DISTRIBUTION_BOX: "/images/services/distribution-box.jpg",
  COPPER_RODS: "/images/services/copper-rods.jpg",
  PLC_PANELS: "/images/services/plc-panels.jpg",
  EARTHING_POWDER: "/images/services/earthing-powder.jpg",
  DG_SYNCHRONIZING: "/images/services/dg-synchronizing.jpg",
  DRIVE_PANELS: "/images/services/drive-panels.jpg",
  CONTROL_DESK: "/images/services/control-desk.jpg",
  TERMINAL_JUNCTION: "/images/services/terminal-junction.jpg",
  FEEDER_PILLAR: "/images/services/feeder-pillar.jpg",
  UNITIZED_SUBSTATION: "/images/services/unitized-substation.jpg",
  ELECTRICAL_PROJECTS: "/images/services/electrical-projects.jpg",
  ELECTRICAL_RACEWAY: "/images/services/electrical-raceway.jpg",
  DIGITAL_CONTROL: "/images/services/digital-control.jpg",
  REPAIR_MAINTENANCE: "/images/services/repair-maintenance.jpg",
  PANEL_INSTALLATION: "/images/services/panel-installation.jpg",
  ELECTRICAL_RELAY: "/images/services/electrical-relay.jpg",
  POWER_DISTRIBUTION: "/images/services/power-distribution.jpg",
  COMMERCIAL_SERVICES: "/images/services/commercial-services.jpg",
  CONTROL_PANELS: "/images/services/control-panels.jpg",
  EARTHING_STRIP: "/images/services/earthing-strip.jpg",
  APFC_RELAYS: "/images/services/apfc-relays.jpg",
  INDUSTRIAL_STABILIZER: "/images/services/industrial-stabilizer.jpg",
  ELECTRICAL_RISING: "/images/services/electrical-rising.jpg",
  ELECTRICAL_CABLE: "/images/services/electrical-cable.jpg",
  LIGHTNING_ARRESTER: "/images/services/lightning-arrester.jpg",
  ACB_PANELS: "/images/services/acb-panels.jpg",
  ELECTRICAL_TURNKEY: "/images/services/electrical-turnkey.jpg",
  BUS_DUCTS: "/images/services/bus-ducts.jpg",
  CAPACITORS_INSULATORS: "/images/services/capacitors-insulators.jpg",
};

export const PROJECT_IMAGES = {
  COMMERCIAL: "/images/projects/commercial-building.jpg",
  RESIDENTIAL: "/images/projects/residential-complex.jpg",
  INDUSTRIAL: "/images/projects/industrial-plant.jpg",
};

export const GALLERY_IMAGES = [
  "/images/gallery/gallery-1.jpg",
  "/images/gallery/gallery-2.jpg",
  "/images/gallery/gallery-3.jpg",
  "/images/gallery/gallery-4.jpg",
  "/images/gallery/gallery-5.jpg",
  "/images/gallery/gallery-6.jpg"
]; 